import { Component, Input } from "@angular/core";

@Component({
  selector: 'rma-status',
  templateUrl: './rma-status.component.html'
})
export class RmaStatusComponent {
  @Input()
  status!: string
}